import { Component, Injector, Input, OnInit } from '@angular/core';
import { isEmpty, size, toUpper } from 'lodash';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { TransactionDetails } from 'src/app/shared/interfaces/User';
import { IS_TRANSACTION_ORDER } from 'src/app/shared/utils/transaction_utils';

@Component({
  selector: 'app-user-voucher-details',
  templateUrl: './user-voucher-details.component.html',
  styleUrls: ['./user-voucher-details.component.scss'],
})
export class UserVoucherDetailsComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() details: TransactionDetails | null | undefined;

  brandName: string = '';
  productName: string = '';
  orderID: any;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.renderOrderID();
    this.renderProductName();
    this.renderBrandName();
  }

  renderProductName() {
    const type = toUpper(this.details?.type);
    const transaction = this.details?.transaction_object;

    if (IS_TRANSACTION_ORDER(type)) {
      if (!isEmpty(transaction?.lines) && size(transaction?.lines) > 0) {
        const lines = transaction?.lines;
        const line = lines?.[0];
        const item = line?.item;
        this.productName = item?.description || '';
      } else if (!isEmpty(transaction?.items) && size(transaction?.items) > 0) {
        const items = transaction?.items;
        const item = items?.[0];
        this.productName = item?.item_name || '';
      }
    }
  }

  renderOrderID() {
    const type = toUpper(this.details?.type);
    const transaction = this.details?.transaction_object;

    if (IS_TRANSACTION_ORDER(type)) {
      this.orderID = transaction?.id!;
    }
  }

  renderBrandName() {
    const type = toUpper(this.details?.type);
    const transaction = this.details?.transaction_object;

    if (IS_TRANSACTION_ORDER(type)) {
      if (!isEmpty(transaction?.lines) && size(transaction?.lines) > 0) {
        const lines = transaction?.lines;
        const line = lines?.[0];
        const item = line?.item;

        this.getURLBrandName(item?.url!);
      }
    }
  }

  public async getURLBrandName(url: string) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const result = await response.json();
      const product = result?.product;
      const brand = product?.brand;
      if (!isEmpty(brand)) {
        this.brandName = brand?.name;
      }
    } catch (error) {
      // console.error(error);
      this.brandName = '';
    }
  }
}
